// Constants

export const aytyErrorLabel = "#AYTY_EXCEPTION:";

export const defaultNS = "commons";

export const i18nLanguage = "i18nextLng";

export const languages = ["pt", "en", "es"];

export const toastTime = 3000;

export const unauthorizedCode = -999;

// Environment variables

export const homBasePath = process.env.REACT_APP_HOM_BASE_PATH;

export const prodBasePath = process.env.REACT_APP_PROD_BASE_PATH;

export const pathDivider =
  process.env.REACT_APP_PATH_DIVIDER || "CRMCloudWebAPI";

export const projectVersion =
  process.env.REACT_APP_PROJECT_VERSION || "x.x.x.xxx";

// Regex

export const validPassword = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,}$/;
